import React from 'react';
import { TreeSelect } from 'antd';
/**
 * 下拉树菜单元件
 */
export const TreeSelectForm = ({
  form,
  name,
  formFieldOptions = {},
  children,
  record,
  initialValue,
  rules,
  onChange,
  ...otherProps
}) => {
  // --
  const { getFieldDecorator } = form;

  let initval = initialValue;

  if (record && name) {
    let nameArray = name.split(".");
    let generateInitVal = record;
    nameArray.forEach(function(value,key,arr){　　//值，索引，数组（默认为选定数组）
      if(generateInitVal)
      generateInitVal = generateInitVal[value];
    });
    
    initval = generateInitVal;
  }
  
  // 如果存在初始值
  if (initval !== null && typeof initval !== 'undefined') {
    formFieldOptions.initialValue = initval;
  }

  // 如果有rules
  if (rules && rules.length) {
    formFieldOptions.rules = rules;
  }

  // 如果需要onChange
  if (typeof onChange === 'function') {
    formFieldOptions.onChange = value => onChange(form, value); // form, value
  }

  return getFieldDecorator(name, formFieldOptions)(
    <TreeSelect {...otherProps} />
  );
};

export default TreeSelectForm;



// WEBPACK FOOTER //
// ./src/components/Form/TreeSelectForm.js